import React from 'react';
import '../style.scss';
import UQIcon from '../../icon';

interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isExpanded?: boolean;
  onToggle?: () => void;
}

const AccordionItem: React.FC<AccordionItemProps> = ({ title, children, isExpanded = false, onToggle }) => {
  return (
    <div className={`accordion-item ${isExpanded ? 'expanded' : ''}`}>
      <div className="accordion-header" onClick={onToggle}>
        <h2>{title}</h2>
        <span className="accordion-icon">{isExpanded ? <UQIcon icon='chevron-up'/> : <UQIcon icon='chevron-down'/>}</span>
      </div>
      {isExpanded && <div className="accordion-body">{children}</div>}
    </div>
  );
};

export default AccordionItem;